import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, onClose, onIndex, title }) {
  const prev = useCallback(
    () => onIndex((index - 1 + images.length) % images.length),
    [index, images.length, onIndex]
  );
  const next = useCallback(
    () => onIndex((index + 1) % images.length),
    [index, images.length, onIndex]
  );

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, prev, next]);

  return (
    <div
      className="fixed inset-0 z-[60] bg-navy/95 backdrop-blur-sm flex flex-col"
      data-testid="lightbox"
      onClick={onClose}
    >
      <div className="flex items-center justify-between px-5 py-4 text-white/80">
        <span className="text-sm font-medium truncate pr-4">
          {title} — {index + 1} / {images.length}
        </span>
        <button onClick={onClose} data-testid="lightbox-close" className="p-2 hover:text-white" aria-label="Kapat">
          <X className="h-6 w-6" />
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 pb-6" onClick={(e) => e.stopPropagation()}>
        <button onClick={prev} data-testid="lightbox-prev" className="p-3 text-white/70 hover:text-white shrink-0" aria-label="Önceki">
          <ChevronLeft className="h-8 w-8" />
        </button>
        <img
          src={images[index]}
          alt={`${title} ${index + 1}`}
          className="max-h-[80vh] max-w-[86vw] object-contain shadow-2xl"
        />
        <button onClick={next} data-testid="lightbox-next" className="p-3 text-white/70 hover:text-white shrink-0" aria-label="Sonraki">
          <ChevronRight className="h-8 w-8" />
        </button>
      </div>

      <div className="hidden sm:flex gap-2 justify-center pb-5 overflow-x-auto no-scrollbar px-4" onClick={(e) => e.stopPropagation()}>
        {images.map((img, i) => (
          <button
            key={img}
            onClick={() => onIndex(i)}
            className={`h-14 w-20 shrink-0 overflow-hidden border-2 transition-all ${
              i === index ? "border-white" : "border-transparent opacity-50 hover:opacity-100"
            }`}
          >
            <img src={img} alt="" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
}
